export enum PriceMethodType {
  ServiceAreas = 'ServiceAreas',
  Locations = 'Locations',
  Vehicle = 'Vehicle',
}
